import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzTabsModule } from '@blk/daisy/combinations/tabs';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DisclosureModule } from '@ddt-web/disclosure';
import { ErrorPopupService } from '@ddt-web/error-handler';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { HeaderModule } from '@ddt-web/navigation';
import { NewFeatureHighlightsModule } from '@ddt-web/new-feature-highlights';
import { NotificationsModule } from '@ddt-web/notifications';

import { FamilyDetailsContainerRoutingModule } from './family-details-container-routing.module';
import { FamilyDetailsContainerComponent } from './family-details-container.component';

@NgModule({
	declarations: [FamilyDetailsContainerComponent],
	imports: [
		CommonModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		DisclosureModule,
		FamilyDetailsContainerRoutingModule,
		HeaderModule,
		NewFeatureHighlightsModule,
		NotificationsModule,
		GenericDirectivesModule,
		DzTabsModule
	],
	providers: [ErrorPopupService]
})
export class FamilyDetailsContainerModule { }
